/**
 * Proxy to track pageviews through analytics services
 */
export function trackPageView() {
  // ga
  if (window && window.gtag) {
    window.gtag('set', 'page_path', `${window.location.pathname}${window.location.search}`)
    window.gtag('event', 'page_view')
  }

  if (window && window.plausible) {
    const spaPageView = {
      u: `${window.location.origin}${window.location.pathname}${window.location.search}`,
    }

    window.plausible('pageview', spaPageView)
  }
}

/**
 * Proxy to track event through analytics services
 */
export function trackEvent({
  action = '',
  category = '',
  label = '',
  extraData = {},
  transport = '',
  callback = null,
}) {
  // ga
  if (window && window.gtag) {
    const eventPayload = {}
    eventPayload.event_label = label
    eventPayload.event_category = category

    if (transport) {
      eventPayload.transport_type = transport
    }

    if (callback) {
      eventPayload.event_callback = callback
    }

    // console.log('event', action, eventPayload, transport)
    window.gtag('event', action, eventPayload)
  }

  if (window && window.plausible) {
    const eventPayload = {
      props: {
        ...extraData,
        label,
        action,
      },
    }

    if (callback) {
      eventPayload.callback = callback
    }

    // console.log('event', category, eventPayload)
    window.plausible(category, eventPayload)
  }
}

/**
 * Helper method that can be used to attached to future dynamic links
 * after dom loads
 */
export function trackLink(e) {
  if (window && (window.gtag || window.plausible)) {
    e.preventDefault()

    // extract data attributes
    const { dataset } = e.currentTarget
    const url = e.currentTarget.href
    // console.log('send', 'event', dataset.category, dataset.action, dataset.label, url);

    // safe handler to only trigger once
    let redirecting = false
    const redirect = () => {
      if (redirecting) {
        return
      }

      redirecting = true
      document.location = url
    }

    trackEvent({
      category: dataset.category,
      action: dataset.action,
      label: dataset.label,
      transport: 'beacon',
      callback: redirect,
    })

    // if hitCallback is not called for whatever reason, redirect w/o waiting
    setTimeout(redirect, 1000)
  }
}

/**
 * After dom loads, attach GA events to static / blade links by .js-event-link class.
 *
 * Does not attach to any dynamic links or vue links as those are created
 * after dom loads.
 */
export function trackLinkInit() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.js-event-link').forEach((link) => {
        link.addEventListener('click', trackLink)
      })
    })
    return
  }

  // if dom already loaded
  document.querySelectorAll('.js-event-link').forEach((link) => {
    link.addEventListener('click', trackLink)
  })
}
